import { create } from 'zustand';

interface FullscreenState {
  isFullscreen: boolean;
  entityName?: string;
  enterFullscreen: (entityName: string) => void;
  exitFullscreen: () => void;
  toggleFullscreen: (entityName: string) => void;
}

export const useFullscreen = create<FullscreenState>((set, get) => ({
  isFullscreen: false,
  entityName: undefined,
  
  enterFullscreen: (entityName: string) => {
    set({ isFullscreen: true, entityName });
  },
  
  exitFullscreen: () => {
    set({ isFullscreen: false, entityName: undefined });
  },
  
  toggleFullscreen: (entityName: string) => {
    const { isFullscreen } = get();
    if (isFullscreen) {
      set({ isFullscreen: false, entityName: undefined });
    } else {
      set({ isFullscreen: true, entityName });
    }
  },
})); 